import { GraphQLClient } from "graphql-request"
import { ENV } from "../ENV"
import { RequestDocument, Variables } from "graphql-request/dist/types"

// FIXME: Explorar essa característica dinâmica
export const GQL = {
  // FIXME: Como melhor mapear no typescript essa delegação de função
  request<T>(document: RequestDocument, variables?: Variables) {
    const client = new GraphQLClient(ENV.GQL_ENDPOINT, {
      headers: {
        authorization: `Token token=${ENV.AUTH_TOKEN}`,
      },
    })

    return client.request<T>(document, variables)
  },
}
